import React from 'react';
import { Link } from 'react-router-dom';
import {
    navigationLinks,
    policyLinks,
    appQuickLinks,
    socialLinks,
    getCopyrightText,
} from './footerData';
import SocialIcon from './SocialIcons';
import './Footer.css';

function FooterLink({ link }) {
    if (link.url.startsWith('http')) {
        return (
            <a href={link.url} target="_blank" rel="noopener noreferrer" className="site-footer-link">
                {link.title}
            </a>
        );
    }

    return (
        <Link to={link.url} className="site-footer-link">
            {link.title}
        </Link>
    );
}

function SocialIconButtons({ className = '' }) {
    return (
        <ul className={`site-footer-social-icons ${className}`.trim()}>
            {socialLinks.map((link) => (
                <li key={link.url}>
                    <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="site-footer-icon-btn"
                        aria-label={link.title}
                        title={link.title}
                    >
                        <SocialIcon id={link.id} />
                    </a>
                </li>
            ))}
        </ul>
    );
}

function AppFooter() {
    const copyrightText = getCopyrightText();
    return (
        <footer className="site-footer site-footer--app">
            <div className="site-footer-shell">
                <div className="site-footer-main site-footer-main--app">
                    <div className="site-footer-app-top">
                        <div className="site-footer-app-brand">
                            <img src="/img/neuratrader_logo.png" alt="NeuraTrader" className="site-footer-app-logo" />
                            <p className="site-footer-app-tagline">Professional crypto trading automation</p>
                        </div>

                        <nav className="site-footer-app-nav" aria-label="Footer">
                            <ul className="site-footer-app-links">
                                {appQuickLinks.map((link) => (
                                    <li key={link.url}>
                                        <FooterLink link={link} />
                                    </li>
                                ))}
                            </ul>
                        </nav>

                        <SocialIconButtons />
                    </div>

                    <div className="site-footer-app-divider" aria-hidden="true" />

                    <div className="site-footer-app-bottom">
                        <p className="site-footer-copyright">
                            {copyrightText}
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

function MarketingFooter() {
    const copyrightText = getCopyrightText();
    return (
        <footer className="site-footer site-footer--marketing">
            <div className="site-footer-main site-footer-main--marketing">
                <div className="site-footer-container">
                    <div className="site-footer-grid">
                        <section className="site-footer-brand">
                            <img src="/img/neuratrader_logo.png" alt="NeuraTrader" className="site-footer-brand-logo" />
                            <p className="site-footer-brand-text">
                                Automate your crypto strategies with professional trading tools.
                            </p>
                            <SocialIconButtons className="site-footer-social-icons--brand" />
                        </section>

                        <section>
                            <h3 className="site-footer-column-title">Navigation</h3>
                            <ul className="site-footer-links">
                                {navigationLinks.map((link) => (
                                    <li key={link.url}>
                                        <FooterLink link={link} />
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h3 className="site-footer-column-title">Policies</h3>
                            <ul className="site-footer-links">
                                {policyLinks.map((link) => (
                                    <li key={link.url}>
                                        <FooterLink link={link} />
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <section>
                            <h3 className="site-footer-column-title">Connect</h3>
                            <ul className="site-footer-links">
                                {socialLinks.map((link) => (
                                    <li key={link.url}>
                                        <a
                                            href={link.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="site-footer-social-link"
                                        >
                                            <SocialIcon id={link.id} />
                                            {link.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                            <p className="site-footer-connect-note">
                                Follow us for product updates and trading insights.
                            </p>
                        </section>
                    </div>
                </div>
            </div>

            <div className="site-footer-bottom">
                <div className="site-footer-bottom-inner">
                    <p className="site-footer-bottom-text">
                        {copyrightText}
                    </p>
                    <div className="site-footer-bottom-links">
                        <Link to="/terms-and-conditions" className="site-footer-bottom-link">Terms</Link>
                        <Link to="/privacy-policy" className="site-footer-bottom-link">Privacy</Link>
                        <Link to="/cookie-policy" className="site-footer-bottom-link">Cookies</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

/**
 * props:
 * - variant: 'app' | 'marketing'
 */
function SiteFooter({ variant = 'app' }) {
    if (variant === 'marketing') {
        return <MarketingFooter />;
    }

    return <AppFooter />;
}

export default SiteFooter;